import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container, Sprite } from '@pixi/react';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';
import { GAMBLE_CARDS } from '../../../core/constants/gameConstants';

function GambleCard({ x, y, spineKey, animationName, youWinTexture, openedCard, isGambleLose }) {
  const [isShowYouWinTexture, setIsShowYouWinTexture] = useState(false);
  const [spine, setSpine] = useState(null);
  const spineRef = useRef();

  const flipCardEnum = useMemo(() => {
    return {
      [GAMBLE_CARDS.Red]: 'red',
      [GAMBLE_CARDS.Black]: 'black',
    };
  }, []);

  useEffect(() => {
    const spineObject = new Spine({ key: spineKey });
    spineObject.play(animationName, true);
    spineRef.current.addChild(spineObject);
    setSpine(spineObject);
  }, [spineRef, spineKey, animationName]);

  const handleSkeletonChange = useCallback(
    (card) => {
      spine.skeleton.setSkinByName(flipCardEnum[card]);
    },
    [spine, flipCardEnum]
  );

  useEffect(() => {
    if (openedCard) {
      // spine.skeleton.setSkinByName('default');
      spine.play('flip');
      handleSkeletonChange(openedCard);
      spine.addListener(
        'complete',
        () => {
          if (!isGambleLose) setIsShowYouWinTexture(true);
          setTimeout(() => {
            setIsShowYouWinTexture(false);
          }, 1000);
        },
        null,
        'flip'
      );
    }
  }, [openedCard, spine, handleSkeletonChange, isGambleLose]);

  useEffect(() => {
    if (!openedCard && spine) spine.play('idle', true);
  }, [spine, openedCard]);

  return (
    <Container x={x} y={y}>
      <Container ref={spineRef} />
      {isShowYouWinTexture ? (
        <Sprite texture={youWinTexture} anchor={0.5} y={isMobile() ? 58 : 0} />
      ) : null}
    </Container>
  );
}
export default GambleCard;
